import { useLayoutEffect, useRef } from "react";

export const useFocusRestoreWithoutScroll = (active: boolean) => {
	const lastFocusedRef = useRef<HTMLElement | null>(null);

	useLayoutEffect(() => {
		if (active) {
			lastFocusedRef.current =
				document.activeElement instanceof HTMLElement
					? document.activeElement
					: null;
			return;
		}

		lastFocusedRef.current?.focus({ preventScroll: true });
		lastFocusedRef.current = null;
	}, [active]);
};
